import store from "../../Redux/store";
import {setKeys } from "./Keys.reducer";

export function saveKeys(records) {
    store.dispatch(setKeys(records));
  }
  